<template>
  <div class="contents">
    <nyTit1 pathUrl="/yuanqu" :nextShow="false" />
    <!-- 下部分内容开始 -->
    <div class="xia_content">
      <!-- 第1块开始 -->
      <div class="first1">
        <!-- 第1块上部分 -->
        <img src="../assets/img/yuanqu1/right.png" />
        <!-- 第1块下部分 -->
      </div>
      <!-- 第1块 结束-->

      <!-- 第3块 开始-->
      <div class="first3">
        <div class="first3Box">
          <img src="https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/ppt1.png" />
<!--          <el-carousel :interval="5000" arrow="always" indicator-position="outside" height="1254px">-->
<!--            <el-carousel-item v-for="(item, index) in state.carouselItems" :key="index">-->
<!--              <img :src="item.imageUrl" alt="carousel-image" class="carousel-image">-->
<!--            </el-carousel-item>-->
<!--          </el-carousel>-->
        </div>

      </div>

      <!-- 第3块结束-->
      <!-- 第4块 开始-->
      <div class="first4">
        <div class="title"><span class="txt1">基础完善 业态丰富</span><span class="txt2">The industry is clear and well developed</span></div>
        <div class="right_box">
          <h4>第三产业</h4>
          <div class="right_box_content">
            <div class="right_box_content_item" v-for="(item,index) in state.right_c" :key="index" v-on:mouseover="changeActive(index+9)" v-on:mouseout="removeActive(index+9)">
              <div class="right_box_content_item_l">
                <h5><img src="../assets/img/yuanqu1/yz.png" /><span>{{item.name}}</span></h5>
                <p>{{item.intro}}</p>
              </div>
              <img :src="item.img" class="right_box_content_item_r" />
              <bigFont leftMargin="-80%" :topMargin="index==4 ?'-120%':'0'" :txt="item.intro" :title="item.name" :isShow="state.curIndex[index+9]"  />
            </div>
          </div>
        </div>

      </div>
      <!--  第4块结束 -->
      <!-- 第5块开始 -->
      <div class="first5">
        <div class="right_box">
            <h4>第二产业</h4>
            <div class="right_box_content">
              <div class="right_box_content_item" v-for="(item,index) in state.right_b" :key="index" v-on:mouseover="changeActive(index+7)" v-on:mouseout="removeActive(index+7)">
                <div class="right_box_content_item_l">
                  <h5><img src="../assets/img/yuanqu1/yz.png" /><span>{{item.name}}</span></h5>
                  <p>{{item.intro}}</p>
                </div>
                <img :src="item.img" class="right_box_content_item_r" />
                <bigFont leftMargin="-80%"  :topMargin="index==1 ?'-120%':'0'" :txt="item.intro" :title="item.name" :isShow="state.curIndex[index+7]"  />
              </div>
            </div>
          <h4>第一产业</h4>
          <div class="right_box_content">
            <div class="right_box_content_item" v-for="(item,index) in state.right_a" :key="index" v-on:mouseover="changeActive(index+4)" v-on:mouseout="removeActive(index+4)">
              <div class="right_box_content_item_l">
                <h5><img src="../assets/img/yuanqu1/yz.png" /><span>{{item.name}}</span></h5>
                <p>{{item.intro}}</p>
              </div>
              <img :src="item.img" class="right_box_content_item_r" />
              <bigFont leftMargin="-80%" topMargin="-100%" :txt="item.intro" :title="item.name" :isShow="state.curIndex[index+4]"  />
            </div>
          </div>

        </div>
      </div>
      <!-- 第5块结束 -->
    </div>
    <!-- 下部分内容结束 -->
  </div>
  <footer1 />
</template>

<script setup>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
  getCurrentInstance,
} from "vue";
// import waterimg from "@/assets/img/xaiofei/fk.png"

import countTo from "@/components/vue-count-to/src/vue-countTo.vue";
import rightPie from '../components/shangcaixq/right_pie'
import bigFont from '../components/bigFont.vue'
import footer1 from "../components/footer.vue";
import nyTit1 from "@/components/nyTit1.vue";

const { proxy } = getCurrentInstance();
// const timer = ref(null);
const router = useRouter();
const state = reactive({
  url: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img",
  currentTime: "",
  font1:{
    name:"上蔡县国家农村产业融合发展示范园",
    info: "2019年，经国家发改委批准立项，由西北农林科技大学规划设计，上蔡县国家农村产业融合发展示范园开工建设，一期项目投资5.5亿元，总占地面积2745亩，2020年9月被国家发改委等七部委批准为国家农村产业融合发展示范园。几年来，示范园区按照“产业发展为核心、文化旅游为灵魂、休闲体验为价值、健康养生为补充、乡村振兴为目标”的理念，高标准打造了高效农业示范区、现代农业文化展示区、酒文化区、康养区等11个特色功能区，总体规模持续扩大，基础设施日趋完善，产业布局不断优化，引领能力显著增强，已经成为豫南一流的产业生态化、生产智能化、销售电商化、服务多元化的一二三产融合发展展示窗口和示范平台。",
  },
  font2:{
    name:"上蔡县国家农村产业融合发展示范园",
    info: "1. 园区入口  2 .小麦种植示范田  3.产业融合示范中心(现建业大食堂 )4.河南现代农业(小麦)示范园  5.检测中心   6.蔬果生产示范大棚7.田园菜市场  8.医疗康养基地  9.萌宠乐园  10.状元红酒店11 .状元红酒厂  12 儿童乐园  13 .108温棚基地 14.产品加工产业园   15.万亩高标准农田16.防洪风景道",
  },
  font3:{
    name:"立足实际  擘画未来",
    info: "有机融合“两园一区”（国家农村产业融合发展示范园、河南省优质小麦现代产业园、上蔡县5万亩高效节水灌溉示范区），打造豫南现代农业发展高地。",
  },
  font4:{
    name:"立足实际  擘画未来",
    info: "按照“种、养、加、销、游”全产业链一体化开发的思路，深入挖掘现代农业附加功能，探索创新“农业+”“电商+”“旅游+”等经营模式，推动现代农业和农产品加工业、现代服务业互融共通、耦合发展，最终实现农业产业链延伸、产业范围扩展，增值收益共享。",
  },
  right_a:[
    {name:"优质小麦种植基地",intro:"种植优质小麦700亩，其中包含现代小麦示范田67.35亩，是全县重要的小麦品种试验区。",img:require("../assets/img/yuanqu1/img1/right1.png")},
    {name:"优质果蔬种植基地",intro:"拥有高效日光温室大棚108座，占地面积500亩，食用菊花、高品质西瓜、优质草莓、酸甜果番茄、水果辣椒等高档果蔬8000多吨，西瓜、辣椒等均获得国家绿色食品A级认证。 ",img:require("../assets/img/yuanqu1/img1/right2.png")},
    {name:"现代农业研学基地",intro:"投资3000万元，建设占地20亩的智能玻璃温室，建筑面积9984平方米，兼具育苗服务、研学观光、示范引领、消费体验等功能，示范引领带动全县农业种植水平上台阶。 ",img:require("../assets/img/yuanqu1/img1/right3.png")}
  ],
  right_b:[
    {name:"状元红酒生产基地",intro:"投入资金1.5亿元，占地200亩的集生产加工销售、酒文化体验为一体的酒文化生产区，年生产上蔡县历史名酒状元红系列白酒1080吨，产品广销省内外。",img:require("../assets/img/yuanqu1/img1/right4.png")},
    {name:"优质农特产品加工企业孵化中心",intro:"新建标准化厂房7栋，总建筑面积15000平方米，作为全县优质农特产品加工企业孵化中心，已筛选入驻最状元酸辣粉、古醇香油、“本草花开”蒲公英茶等极具我县特色的加工企业7家。",img:require("../assets/img/yuanqu1/img1/right5.png")},

  ],
  right_c:[
    {name:"电商基地",intro:"建筑面积5000平米，面向电子商务企业、传统企业，开展全方位管、孵化、陪跑等服务，打造全省领先的综合电商基地。",img:require("../assets/img/yuanqu1/img1/right6.png")},
    {name:"冷链仓储基地",intro:" 建筑面积2500平米其中冷冻库2000平米贮存能力约10000吨，冷藏500平方米，贮存能力2000吨。",img:require("../assets/img/yuanqu1/img1/right9.png")},
    {name:"检测中心",intro:"建筑面积3600平方米，拥有食品、食品添加剂、农产品、农资类产品等471个产品检测资质和928个相关参数的检测能力。",img:require("../assets/img/yuanqu1/img1/right7.png")},
    {name:"养老中心",intro:"建筑面积9000平方米采用英国D.W.A公司设计理念，打造集健康休养、医疗护理和文化娱乐于一体的康养中心。",img:require("../assets/img/yuanqu1/img1/right8.png")},
    {name:"生态温泉酒店",intro:"建筑面积9600平方米，集会议、餐饮、住宿、洗浴为一体的状元红生态温泉酒店，能同时容纳1000人会议和就餐。",img:require("../assets/img/yuanqu1/img1/right10.png")}
  ],

  options: {
    // src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/scxc.mp4", //视频源
    src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/scxx.mp4", //视频源
    type: "video/mp4", //视频类型
  },
  carouselItems: [
    { imageUrl: 'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/ppt/yq1 (1).png'},
    { imageUrl: 'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/ppt/yq1 (2).png' },
    { imageUrl: 'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/ppt/yq1 (3).png'},
    { imageUrl: 'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/ppt/yq1 (4).png'},
    { imageUrl:'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/ppt/yq1 (5).png' },
    { imageUrl:'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/ppt/yq1 (6).png'}
  ],
  curIndex:[false,false,false,false,false,false,false,false,false],
});
onMounted(() => {
  // setInterval(()=>{
  //   state.endVal = 87662
  // },5000)
});
onUnmounted(() => {
  // 清理资源
});
onBeforeUnmount(() => {
  // clearInterval(timer.value);
});
// 返回上一页
function clickReturn() {
  router.go(-1);
}
function removeActive(num){
  state.curIndex[num]= false
}
function changeActive(num){
  console.log(num)
  state.curIndex[num]=true
  console.log(state.curIndex)
}
</script>

<style lang="less" scoped>
#video1 .d-player-wrap {
  object-fit: cover;
  // background-color: #ff0000 !important;
  background-color: transparent !important; /* 设置背景色为透明 */
}
::v-deep .el-carousel__arrow{
  font-size:80px
}
.contents {
  width: 100%;
  height: 100%;
  width: 100%;
  height: 100%;
  background: url("@{url}/img/xqbj1.png") no-repeat top center;
  background-size: 100% 100%;
  position: relative;
  overflow: hidden;
  .xia_content {
    width: 100%;
    height: calc(100% - 180px);
    // border: #fff 1px solid;
    margin-top: 180px;
    display: flex;
    padding-bottom: 40px;
    box-sizing: border-box;
    .first1 {
      width: 1769px;
      height: 100%;
      display: flex;
      flex-direction: column;
      margin: 0 50px 0 30px;

    }

    .first3 {
      flex: 1;
      height: calc(100% - 100px);
      background: url("../assets/img/shancaixianqing/xq/spk@2x.png") no-repeat;
      background-size: 100% 100%!important;
      margin: 100px 30px;
      padding: 30px;
      box-sizing: border-box;
      overflow: hidden;
      .first3Box{
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
        img{
          //height: 100%;
        }
      }

    }


    .first4 {
      width: 854px;
      height: 100%;
      background: url("../assets/img/shancaixianqing/xq/k4.png") no-repeat;
      background-size: 100% 100%!important;
      margin: 0 30px;
      display: flex;
      flex-direction: column;

    }
    .right_box{
      padding: 20px 30px;
      h4{
        font-size: 30px;
        background: linear-gradient(to bottom, #fff 25%, #abdfff 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-style: italic;
        font-weight: bold;
        text-align: left;
      }
      .right_box_content{
        .right_box_content_item{
          display: flex;
          color: #fff;
          justify-content: space-between;
          position: relative;
          cursor: pointer;
          margin-top:30px;
          .right_box_content_item_l{
            flex: 1;
            text-align: left;
            margin-right: 40px;
            h5{
              width: 100%;
              height: 70px;
              display: flex;
              align-items: center;
              background: linear-gradient( 90deg, #043563 0%, rgba(4,53,99,0.32) 100%);
              color: #F2F6FA;
              line-height: 70px;
              text-align: left;
              font-size: 30px;
              margin-bottom: 20px;
              img{
                width: 48px;
                height: 48px;
              }
              span{
                display: block;
                height: 70px;
                flex: 1;
                overflow: hidden;
                text-overflow: ellipsis;
                -webkit-box-orient: vertical;
                - webkit-line-clamp:1;
              }
            }
            p{
              font-size: 30px;
              line-height: 50px;
              text-indent: 2em;
              height: 110px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp:2 ;
            }
          }
          .right_box_content_item_r{
            width: 326px;
            height: 211px;
            // transform: scale(0.9);
          }
        }
      }
    }
    .first5 {
      width: 729px;
      height: 100%;
      background: url("../assets/img/shancaixianqing/xq/k5.png") no-repeat;
      background-size: 100% 100%!important;
      box-sizing: border-box;
      margin-right: 30px;
      .right_box{
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom:30px;
        //border: 1px solid;
        .right_box_content{
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }

      }

    }

  }

  // 标题
  .title{
    width: 100%;
    height: 60px;
    padding-left: 50px;
    box-sizing: border-box;
    line-height: 60px;
    color: #fff;
    background: url("../assets/img/shancaixianqing/xq/bt1.png") no-repeat;
    display: flex;
    span{display: block;}
    .txt1 {
      font-size: 30px;
      background: linear-gradient(to bottom, #fff 25%, #abdfff 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-style: italic;
      font-weight: bold;
      padding: 0 10px;
    }
    .txt2 {
      color: #0287ba;
      margin-left: 20px;
      font-size: 22px;
      font-family: Arial, Helvetica, sans-serif;
    }
  }
  .fontStyle{
    font-size: 30px;
    text-align: left;
    padding: 20px 30px;
    color: rgba(255, 255, 255, 0.7);
    line-height: 50px;
    text-indent: 2em;
  }
}
</style>
